module.exports = {
  baseApi: process.env.VUE_APP_BASE_API || 'http://localhost:3000',
  firebaseConfig: {
    apiKey: "AIzaSyCl43OYYUDMFCM4-hXDABkOs7gSdKLukcA",
    authDomain: "dominguez-e0dc6.firebaseapp.com",
    databaseURL: "https://dominguez-e0dc6.firebaseio.com",
    projectId: "dominguez-e0dc6",
    storageBucket: "dominguez-e0dc6.appspot.com",
    messagingSenderId: "39385192833",
    appId: "1:39385192833:web:5e0ed375b3cb359f79f080"
  },
  firebasePublicVapidKey: 'BPnUfkZfHBwKmAMdHJRs_3Hq-dmzNJxBf8J-0WDsf_tJcET07dLKw78qufGwsg0ZZK297tZtdTgrHfFciyUYkvQ',
  firebaseServerKey: 'AAAACSuKWYE:APA91bHmzNAuxHWP5pBRLOA3PdZVgd-_x6HN7krbzx56SinzXn6Bjjh1_1tad5QpUeOh2YVZUUxsW13xoIDnoutLd4dFqurF4WqTJkEBh5yExw3MNdsGbPVle6Z34fehlS_xEM4QQUuL'
}
